exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".organization-cmp .validation-msg {\n  margin-bottom: 0px; }\n\n.organization-cmp form .form-group {\n  margin-bottom: 0.5rem; }\n\n.organization-cmp form .form-section {\n  line-height: 2rem;\n  margin-bottom: 10px; }\n\n.organization-cmp .static-region {\n  margin-bottom: 0;\n  font-weight: bold; }\n\n.organization-cmp .modify-closing-status {\n  text-decoration: underline;\n  margin-right: 20px;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/organization/organization.component.scss
// module id = ../../../../../src/app/authorized/organization/organization.component.scss
// module chunks = main